import "./App.css";
import Experience from "./components/Experience/Experience";
import Header from "./components/Header/Header";
import { lazy, Suspense } from "react";

const Body = lazy(() => import("./components/Body/Body"));
const About = lazy(() => import("./components/About/About"));
const Contact = lazy(() => import("./components/Contact/Contact"));
const Work = lazy(() => import("./components/MyWork/MyWork"));

const PageLoader = () => {
  return (
    <div className="section-loader" role="status" aria-live="polite">
      <div className="section-loader__ring" aria-hidden="true"></div>
      <p className="section-loader__text">Loading section...</p>
    </div>
  );
};

function App() {
  return (
    <div className="bg-white dark:bg-gray-900">
      <Header />
      <main>
        <section id="home" className="scroll-mt-20">
          <Suspense fallback={<PageLoader />}>
            <Body />
          </Suspense>
        </section>

        <section id="about" className="scroll-mt-20">
          <Suspense fallback={<PageLoader />}>
            <About />
          </Suspense>
        </section>

        <section id="mywork" className="scroll-mt-20">
          <Suspense fallback={<PageLoader />}>
            <Work />
          </Suspense>
        </section>

        <section id="experience" className="scroll-mt-20">
          <Suspense fallback={<PageLoader />}>
            <Experience />
          </Suspense>
        </section>

        <section id="contact" className="scroll-mt-20">
          <Suspense fallback={<PageLoader />}>
            <Contact />
          </Suspense>
        </section>
      </main>
    </div>
  );
}

export default App;
